import { Link } from 'react-router-dom'

const NewWomenOfChaashni = () => {
  return (
<div className='womenofchaashninew'>
  <div className='container'>
<Link to="/category/shop?shipping=7+Days_Within+7+days&orderBy=default">
    <div className='container-womenofchaashnibox'>
      <div className='womenofchaashnibox'> {/* <span className='imgwomenofchaashni'><img src="images/flower.png" alt="Ready to ship styles at special price" width="100%" height="auto" /></span> */}
        <p>Ready to ship styles at special prices</p>
        <span className='linkwc'>Explore</span>
      </div>
    </div>
</Link>
  </div>
</div>
)
}
export default NewWomenOfChaashni 